import { cn } from 'noddi-ui-common';
import { commonTexts } from 'noddi-util';

type Translations = typeof commonTexts.stepProgress;

type Props = {
  /** 1-based; every segment up to and including it is filled. */
  current: number;
  total: number;
  translations?: Partial<Translations>;
  className?: string;
};

/**
 * How far a user is through a linear flow: "Step 2 of 5" over one segment per step. Display only —
 * a flow whose finished steps are revisited from the bar is a wizard, `NoddiStepFlow`.
 */
export const NavioStepProgress = ({ current, total, translations, className }: Props) => {
  const texts = { ...commonTexts.stepProgress, ...translations };
  const label = texts.stepOf(current, total);

  return (
    <div
      role='progressbar'
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
      aria-valuetext={label}
      className={cn('flex w-full flex-col gap-3', className)}
    >
      <span className='text-sm font-medium text-primary'>{label}</span>
      <div aria-hidden className='flex gap-1 md:gap-1.5'>
        {Array.from({ length: total }, (_, index) => (
          <span
            key={index}
            className={cn(
              'h-1 flex-1 rounded-full motion-safe:transition-colors motion-safe:duration-300 motion-safe:ease-out',
              index < current ? 'bg-primary' : 'bg-primary/12'
            )}
          />
        ))}
      </div>
    </div>
  );
};
